<template>
  <div class="container">
    <div class="board main">
        <div class="logo">
            <img :src="`${publicPath}/images/logo.svg`">
        </div>
        <div class="buttons">
            <a class="button red" @click="select('PlatesComponent', 'right')">START</a>
            <a class="button blue" @click="select('ShareComponent', 'bottom')">SHARE</a>
            <a :href="`${publicPath}/download/answq.pdf`" target="_blank" class="button green">PRINT</a>
        </div>
        <div class="footer">
            <p class="copyright">Presented by <a href="https://www.kokuchpro.com/" target="_blank">こくちーずプロ</a></p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeComponent',
  methods: {
    select: function(viewName, transitionName) {
      this.changeView({viewName, transitionName})
    }
  }
}
</script>
